<template>
  <require from="controls/as-widget-container"></require>
  <require from="controls/as-form-section.html"></require>

  <as-form-section heading.bind="sectionHeading" intro.bind="sectionIntro">
    <div slot="body">
      <as-widget-container kind.bind="deviationDetailWidget" model.bind="model" disabled.bind="disabled"></as-widget-container>
    </div>
  </as-form-section>
</template>
